<template>
  <div class="tw-flex tw-flex-col tw-gap-6" :class="textSize">
    <a v-if="email" :href="`mailto:${email}`">
      <div class="tw-flex tw-gap-4">
        <div class="tw-h-12 tw-w-12" :class="secondaryIcon">
          <EmailIcon class="!tw-h-6 !tw-w-6" :class="secondaryIcon" />
        </div>
        <div>
          <div class="tw-font-semibold tw-text-gray-800">{{ emailLabel }}</div>
          <div class="tw-break-all tw-font-normal tw-text-blue-700 hover:tw-underline">
            {{ email }}
          </div>
        </div>
      </div>
    </a>

    <a v-if="phone" :href="`tel:+1${phone}`">
      <div class="tw-flex tw-gap-4">
        <div
          class="tw-flex tw-h-12 tw-w-12 tw-flex-shrink-0 tw-content-center tw-items-center tw-justify-center tw-rounded-full"
          :class="secondaryIcon"
        >
          <CallIcon class="!tw-h-6 !tw-w-6" :class="secondaryIcon" />
        </div>
        <div>
          <div class="tw-font-semibold tw-text-gray-800">{{ phoneLabel }}</div>
          <div class="tw-font-normal tw-text-blue-700 hover:tw-underline">
            {{ formatPhoneNumber(phone) }}
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script setup lang="ts">
import CallIcon from '~icons/fluent/call-16-filled'
import EmailIcon from '~icons/fluent/mail-16-filled'

withDefaults(
  defineProps<{
    textSize?: string
    emailLabel?: string
    phoneLabel?: string
  }>(),
  {
    textSize: 'tw-text-[18px]',
    emailLabel: 'Email us at:',
    phoneLabel: 'Call us at:',
  },
)

const branding = useBrand() as Ref<BrandingState>
const { getThemeToken } = useTheme()
const secondaryIcon = getThemeToken('secondary-icon')

const email = computed(() => {
  const brandingState = branding as Ref<BrandingState>
  return brandingState.value.supportEmail ?? null
})

const phone = computed(() => {
  const brandingState = branding as Ref<BrandingState>
  return formatPhoneNumber(brandingState.value.outreachNumber) ?? null
})
</script>
